module.exports = __webpack_public_path__ + "static/media/wheel-2.bef8e782.webp";